import { IGLAccountState } from '@/store/accounting';
import { IGLAccountMutations } from './mutations.types';
import { IGLAccountData } from '@/models';

export const mutations: IGLAccountMutations = {
  SET_GL_ACCOUNTS(state: IGLAccountState, payload: IGLAccountData[]): void {
    state.accounts = payload;
  },

  ADD_GL_ACCOUNT(state: IGLAccountState, payload: IGLAccountData): void {
    state.accounts.push(payload);
  },

  UPDATE_GL_ACCOUNT(state: IGLAccountState, payload: IGLAccountData): void {
    const index = state.accounts.findIndex(
      (account: IGLAccountData) => account.id === payload.id
    );

    state.accounts.splice(index, 1, payload);
  },

  REMOVE_GL_ACCOUNT(state: IGLAccountState, payload: number): void {
    const index = state.accounts.findIndex(
      (account: IGLAccountData) => account.id === payload
    );

    state.accounts.splice(index, 1);
  }
};
